var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSelect',{staticClass:"formulate-vselect",attrs:{"options":_vm.options,"label":"label","reduce":_vm.reduceOption,"multiple":_vm.multiple,"clearable":!_vm.multiple,"placeholder":_vm.placeholder,"value":_vm.context.model},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }